<template>
    <div class="con_content">
      <div class="comH">
        <!-- table组件 -->
            <div class="my_table  ">
                <Header class="my_title txt_l">
                    <span class="my_titleL">
                    <Icon class="fw_900 " type="ios-list" size='30'/>     
                        数据列表 
                    </span>
                    
                    <div class="ct_rgt">                      
                        <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> 
                    </div>
                </Header>
                <Table border :columns="columns1" :data="data1" ref='table'>
                
                    <!-- 头像 -->
                    <template slot-scope="{ row }" slot="image">
                        <div class="demo-avatar">
                            <Avatar v-if="row.image == null" icon="ios-person" size="large" />
                            <Avatar v-else  :src="row.image" size="large"/> 
                        </div>                        
                    </template>

                    <!-- 按钮 -->
                    <template slot-scope="{ row }" slot="btn">
                       
                        <Poptip trigger="hover"  content="删除">
                            <Button class="padlr5" size="small"  @click="guid=row.guid;userName=row.name;delM=true;"  type="error"    icon="md-close"  ></Button>
                        </Poptip>    
                    </template>
                    
                </Table>
                <!-- <Footer>
                    <Page  :current.sync="page" :total="totalPage" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer />
                </Footer> -->
               
            </div>
       </div>
       <!-- 确认删除框 -->
        <Modal
            v-model="delM"
            title="提示"
            @on-ok="delOk"
            @on-cancel="delM=false"
            class-name="vertical-center-modal"
        >
            <p>确定删除{{userName}}的这条回复吗? </p>         
        </Modal>  
    </div>
</template>
<script >

    export default{
        
        data(){
            return{
                guid: null,
                userName: null,
                totalPage: 0, 
                page: 1,
                size: 20,

                data1: [],
                columns1: [],
                delM: false,
            }
        },
        watch:{
            child_guid(val){
                this.load();
            },
            txtM_c(val){
                let that = this;
                if(!val){
                    that.data1 = []
                    
                }else{
                    that.load()
                }
            }

        },
        props: ['child_guid','txtM_c'],
        methods: {
            load(){
                
                this.$myAjax.get('admin/service/trend/comment/reply/get?guid='+this.child_guid).then(res => {
                    let ajax = res.data.data;
                    this.guid = ajax.guid;
                    this.data1 = ajax;
                    this.columns1 = [
                        {title:'ID',key:'number',align:'center',minWidth:80,maxWidth:140},
                        {title:'用户昵称',key:'name',align:'center',minWidth:80,maxWidth:140},
                        {title:'头像',slot:'image',align:'center',width:100},
                        {title:'评论内容',key:'content',render:(h,params) => {
                            return h('span',{
                                domProps:{
                                title: params.row.content
                                }
                            },params.row.content)
                        },align:'left',ellipsis: true},
                        {title:'评论时间',key:'createTime',align:'center',width:180},
                        {title:'操作',slot:'btn',align:'center',width:120,fixed: 'right'}
                    ]
                })
            },
         
            delOk(){
                this.$myAjax.delete('admin/service/trend/comment/reply/delete?guid='+this.guid+'&route=/layout/user/postComment/del').then(res => {
                    this.load();
                })
            },
            change_page(index){
                this.page = index;
                this.load();
            },
            change_size(index){
                this.size = index;
                this.load();
            },
            exportData(){
                var that = this;
                that.$refs.table.exportCsv({
                    filename: '数据列表',
                    original: false
                });
               
            },
        },
        mounted: function(){
            this.load();
            
        }
        
    }
</script>
<style scoped>
    .comH{
        width: 100%;
        height: 600px;
        overflow-y: auto;
    }
</style>